import { getMessageFactoryV2 } from "../getCaxaWebSocketV2.js";
const createOrderFileV3 = getMessageFactoryV2({
  code: "CREATE_ORDER_FILE_TASK"
});
export { createOrderFileV3 };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/createOrderFileV3.js